<template>
<v-hover v-slot="{ hover }">
  <v-card outlined :color="hover ? 'deep-purple lighten-5' : 'white'" :elevation="hover ? 3 : 1" class="settings-card rounded-lg d-flex align-center" @click="handleClick">
    <v-container>
      <v-row dense>
        <v-col cols="4" class="d-flex align-center justify-center">
          <v-avatar :color="hover ? 'white' : 'deep-purple lighten-5'" size="70px">
            <v-icon color="primary" x-large>
              <slot name="icon" />
            </v-icon>
          </v-avatar>
        </v-col>
        <v-col class="my-1">
          <v-card-title class="settings-card__title my-0 py-0">
            <slot />
          </v-card-title>
          <v-card-text class="my-0 py-0 grey--text text--darken-1">
            <slot name="description" >
              <v-btn text class="ml-n4 primary--text">
                Configurar
                <v-icon right class="mx-0">
                  mdi-chevron-right
                </v-icon>
              </v-btn>
            </slot>
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</v-hover>
</template>

<script>
export default {
  name: 'SettingsCard',

  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style >
.settings-card {
  min-width: 280px;
  width: 100%
}

.settings-card:hover {
  cursor: pointer;
}

.settings-card__title {
  word-break: normal;
}

.settings-card.v-card--link:focus::before {
  border-radius: 8px;
}
</style>